import { Get } from "../http/httpVerbs";

export const apiGetFranchises = async (communityId) => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/comunidades/${communityId}/franchises`;
        const response = await Get(url);
        return response;
    } catch (error) {
        console.error("Error fetching franchises:", error);
        throw error;
    }
};
